// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UiwOutlinedSvg from "@fishx/icons-svg/es/asn/UiwOutlined";
import FishxIcon from '../components/FishxIcon';

var UiwOutlined = function UiwOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UiwOutlinedSvg
  }));
};

UiwOutlined.displayName = 'UiwOutlined';
export default React.forwardRef(UiwOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UiwOutlined.js
// module id = 4304
// module chunks = 0